export const os = {
  android: "android",
  ios: "ios",
};

export const url = {
  appStoreUrl: "https://apps.apple.com/us/app/nocnoc/id1593814142",
  playStoreUrl:
    "https://play.google.com/store/apps/details?id=com.nocnoc.app.prod",
};

export const fallbackToStorePaths = ["/post", "/idea", "/community"];

export const analytics = {
  segmentKey: process.env.REACT_APP_SEGMENT_WRITE_KEY
}
